<template>
  <div class="dealer-management">
    <el-card class="box-card">
      <!-- 页面头部 -->
      <div class="page-header">
        <div class="title">
          <i class="el-icon-user-solid"></i>
          <span>{{ agentName }} - 经销商管理</span>
        </div>
        <el-button icon="el-icon-back" size="small" @click="handleBack">返回</el-button>
      </div>

      <!-- 搜索区域 -->
      <div class="filter-container">
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="经销商名称">
            <el-input
              v-model="queryParams.dealerName"
              placeholder="请输入经销商名称"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="queryParams.status"
              placeholder="请选择状态"
              clearable
              size="small"
            >
              <el-option label="全部" :value="-1" />
              <el-option label="启用" :value="1" />
              <el-option label="禁用" :value="0" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              size="small"
              @click="handleQuery"
            >搜索</el-button>
            <el-button
              icon="el-icon-refresh"
              size="small"
              @click="resetQuery"
            >重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 操作按钮区域 -->
      <div class="operation-container">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="handleAdd"
        >新增经销商</el-button>
        <el-button size="small" icon="el-icon-back" @click="handleBack">返回</el-button>
        
      </div>

      <!-- 表格区域 -->
      <el-table
        v-loading="loading"
        :data="dealerList"
        border
        style="width: 100%"
      >
        <el-table-column label="经销商名称" prop="dealerName" align="center" />
        <el-table-column label="负责人" prop="charge" align="center" />
        <el-table-column label="负责人电话" prop="chargePhone" align="center" />
        <el-table-column label="联系人" prop="contact" align="center" />
        <el-table-column label="联系人电话" prop="contactPhone" align="center" />
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="handleStatusChange(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              icon="el-icon-edit"
              @click="handleUpdate(scope.row)"
            >编辑</el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-document"
              @click="handleFiles(scope.row)"
            >文件</el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParams.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>

      <!-- 经销商表单对话框 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" append-to-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="经销商名称" prop="dealerName">
            <el-input v-model="form.dealerName" placeholder="请输入经销商名称" />
          </el-form-item>
          <el-form-item label="负责人" prop="charge">
            <el-input v-model="form.charge" placeholder="请输入负责人姓名" />
          </el-form-item>
          <el-form-item label="负责人电话" prop="chargePhone">
            <el-input v-model="form.chargePhone" placeholder="请输入负责人电话" />
          </el-form-item>
          <el-form-item label="联系人" prop="contact">
            <el-input v-model="form.contact" placeholder="请输入联系人姓名" />
          </el-form-item>
          <el-form-item label="联系人电话" prop="contactPhone">
            <el-input v-model="form.contactPhone" placeholder="请输入联系人电话" />
          </el-form-item>
          <el-form-item label="联系地址" prop="address">
            <el-input v-model="form.address" placeholder="请输入联系地址" />
          </el-form-item>
          <el-form-item label="办公电话" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入办公电话" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 文件上传对话框 -->
      <el-dialog title="经销商文件" :visible.sync="fileDialogVisible" width="800px" append-to-body>
        <el-upload
          class="upload-demo"
          :action="uploadUrl"
          :headers="headers"
          :data="uploadData"
          :before-upload="beforeUpload"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          multiple
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png/pdf文件，且不超过10MB</div>
        </el-upload>
        
        <el-table :data="fileList" style="margin-top: 20px">
          <el-table-column label="文件名称" prop="fileName" />
          <el-table-column label="文件类型" prop="fileKind" width="100" />
          <el-table-column label="上传时间" prop="createdAt" width="180" />
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handleDownload(scope.row)"
              >下载</el-button>
              <el-button
                type="text"
                size="small"
                @click="handleDeleteFile(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'DealerManagement',
  data() {
    return {
      // 代理商信息
      agentId: '',
      agentName: '',
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 经销商列表
      dealerList: [],
      // 弹出层标题
      dialogTitle: '',
      // 是否显示弹出层
      dialogVisible: false,
      // 是否显示文件弹出层
      fileDialogVisible: false,
      // 查询参数
      queryParams: {
        page: 1,
        size: 10,
        dealerName: '',
        status: -1,
        agentId: ''
      },
      // 表单参数
      form: {
        dealerId: '',
        agentId: '',
        dealerName: '',
        charge: '',
        chargePhone: '',
        contact: '',
        contactPhone: '',
        address: '',
        phone: '',
        status: 1
      },
      // 表单校验
      rules: {
        dealerName: [
          { required: true, message: '请输入经销商名称', trigger: 'blur' }
        ],
        charge: [
          { required: true, message: '请输入负责人', trigger: 'blur' }
        ],
        chargePhone: [
          { required: true, message: '请输入负责人电话', trigger: 'blur' }
        ]
      },
      // 文件列表
      fileList: [],
      // 上传地址
      uploadUrl: process.env.VUE_APP_BASE_API + '/api/v1/dealer-files/upload',
      // 上传请求头
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
      // 上传参数
      uploadData: {
        dealerId: undefined
      }
    }
  },
  created() {
    // 从路由参数中获取代理商信息
    const { agentId, agentName } = this.$route.query
    this.agentId = agentId
    this.agentName = agentName
    this.queryParams.agentId = agentId
    this.getList()
  },
  methods: {
    /** 查询经销商列表 */
    async getList() {
      try {
        this.loading = true
        const res = await request({
          url: '/api/v1/dealers/list',
          method: 'POST',
          data: this.queryParams
        })

        if (res.status === 1) {
          this.dealerList = res.data
          this.total = res.total
        } else {
          this.$message.error(res.msg || '获取经销商列表失败')
        }
      } catch (error) {
        console.error('获取经销商列表错误:', error)
        this.$message.error('获取经销商列表失败')
      } finally {
        this.loading = false
      }
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1
      this.getList()
    },

    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        page: 1,
        size: 10,
        dealerName: '',
        status: -1,
        agentId: this.agentId
      }
      this.getList()
    },

    /** 返回按钮操作 */
    handleBack() {
      this.$router.push('/sale/agent')
    },

    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.form.agentId = this.agentId
      this.dialogTitle = '添加经销商'
      this.dialogVisible = true
    },

    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset()
      this.form = { ...row }
      this.dialogTitle = '修改经销商'
      this.dialogVisible = true
    },

    /** 表单重置 */
    reset() {
      this.form = {
        dealerId: '',
        agentId: this.agentId,
        dealerName: '',
        charge: '',
        chargePhone: '',
        contact: '',
        contactPhone: '',
        address: '',
        phone: '',
        status: 1
      }
      this.$refs.form && this.$refs.form.resetFields()
    },

    /** 提交表单 */
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const res = await request({
              url: '/api/v1/dealers/save',
              method: 'POST',
              data: this.form
            })

            if (res.status === 1) {
              this.$message.success('保存成功')
              this.dialogVisible = false
              this.getList()
            } else {
              this.$message.error(res.msg || '保存失败')
            }
          } catch (error) {
            console.error('保存经销商错误:', error)
            this.$message.error('保存失败')
          }
        }
      })
    },

    /** 删除按钮操作 */
    async handleDelete(row) {
      try {
        await this.$confirm('是否确认删除该经销商?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const res = await request({
          url: '/api/v1/dealers/delete',
          method: 'POST',
          data: { dealerId: row.dealerId }
        })

        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除经销商错误:', error)
          this.$message.error('删除失败')
        }
      }
    },

    /** 文件相关操作 */
    handleFiles(row) {
      this.uploadData.dealerId = row.dealerId
      this.getFileList(row.dealerId)
      this.fileDialogVisible = true
    },

    async getFileList(dealerId) {
      try {
        const res = await request({
          url: '/api/v1/dealer-files/list',
          method: 'GET',
          params: { dealerId }
        })

        if (res.status === 1) {
          this.fileList = res.data
        } else {
          this.$message.error(res.msg || '获取文件列表失败')
        }
      } catch (error) {
        console.error('获取文件列表错误:', error)
        this.$message.error('获取文件列表失败')
      }
    },

    beforeUpload(file) {
      const isValidType = ['image/jpeg', 'image/png', 'application/pdf'].includes(file.type)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isValidType) {
        this.$message.error('只能上传JPG/PNG/PDF格式文件!')
        return false
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB!')
        return false
      }
      return true
    },

    handleUploadSuccess(response) {
      if (response.status === 1) {
        this.$message.success('上传成功')
        this.getFileList(this.uploadData.dealerId)
      } else {
        this.$message.error(response.msg || '上传失败')
      }
    },

    handleUploadError() {
      this.$message.error('上传失败')
    },

    handleDownload(row) {
      window.open(row.fileUrl)
    },

    async handleDeleteFile(row) {
      try {
        await this.$confirm('是否确认删除该文件?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const res = await request({
          url: '/api/v1/dealer-files/delete',
          method: 'POST',
          data: { fileId: row.fileId }
        })

        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getFileList(this.uploadData.dealerId)
        } else {
          this.$message.error(res.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除文件错误:', error)
          this.$message.error('删除失败')
        }
      }
    },

    /** 状态修改 */
    async handleStatusChange(row) {
      try {
        const res = await request({
          url: '/api/v1/dealers/change-status',
          method: 'POST',
          data: {
            dealerId: row.dealerId,
            status: row.status
          }
        })

        if (res.status === 1) {
          this.$message.success('状态修改成功')
        } else {
          this.$message.error(res.msg || '状态修改失败')
          row.status = row.status === 1 ? 0 : 1
        }
      } catch (error) {
        console.error('修改状态错误:', error)
        this.$message.error('状态修改失败')
        row.status = row.status === 1 ? 0 : 1
      }
    },

    /** 分页方法 */
    handleSizeChange(val) {
      this.queryParams.size = val
      this.getList()
    },

    handleCurrentChange(val) {
      this.queryParams.page = val
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.dealer-management {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 84px);

  .page-header {
    position: relative;
    height: 80px;
    margin: -10px -20px 30px;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(135deg, #1890ff, #36cfc9);
    overflow: hidden;

    /* 添加科技感背景 */
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: linear-gradient(45deg, rgba(255,255,255,0.1) 25%, transparent 25%), linear-gradient(-45deg, rgba(255,255,255,0.1) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, rgba(255,255,255,0.1) 75%), linear-gradient(-45deg, transparent 75%, rgba(255,255,255,0.1) 75%);
      background-size: 20px 20px;
      background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
      animation: backgroundMove 20s linear infinite;
    }

    /* 添加动态光效 */
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: -150%;
      width: 150%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.1),
        transparent
      );
      transform: skewX(-20deg);
      animation: shine 8s infinite;
    }

    .title {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      
      i {
        width: 40px;
        height: 40px;
        margin-right: 12px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        color: #fff;
        backdrop-filter: blur(5px);
      }

      span {
        font-size: 20px;
        font-weight: 500;
        color: #fff;
        text-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
    }
  }

  /* 添加动画 */
  @keyframes backgroundMove {
    0% {
      background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
    }
    100% {
      background-position: -20px -20px, -20px -10px, -10px -30px, -30px -20px;
    }
  }

  @keyframes shine {
    0% {
      left: -150%;
    }
    50% {
      left: 100%;
    }
    100% {
      left: 100%;
    }
  }

  .filter-container {
    padding-bottom: 10px;
  }

  .operation-container {
    margin-bottom: 20px;
  }

  .pagination-container {
    padding: 20px 0;
    text-align: right;
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  .upload-demo {
    margin-bottom: 20px;
  }

  .el-upload__tip {
    line-height: 1.2;
    margin-top: 5px;
    color: #909399;
  }
}
</style>
